
const digest = '1f823d0468ae29f4a801598c7ed9a6d4b079be891b0bc97dfd7a08f7274517fe';
const css = `._container_13606_1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"container":"_container_13606_1"};
export { css, digest };
  